﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customDepartmentResetList from './tpl/customDepartmentResetList.html';
import View_CustomDepartmentResetListItem from './customDepartmentResetListItem';

export default Marionette.CollectionView.extend({
    //tagName: 'customDepartmentResetList',
   // tagName: 'ul',
  //  className: 'd-flex flex-column-reverse todo-list',
    childViewContainer: '#customDepartmentResetList',
    childView: View_CustomDepartmentResetListItem,
    getTemplate: function () {
        return tpl_customDepartmentResetList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});